import { render } from "./sdgd.vue?vue&type=template&id=9842b782&scoped=true&ts=true"
import script from "./sdgd.vue?vue&type=script&lang=ts"
export * from "./sdgd.vue?vue&type=script&lang=ts"

import "./sdgd.vue?vue&type=style&index=0&id=9842b782&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9842b782"]])

export default __exports__